import React from 'react';
import { Box, Tooltip, Typography } from '@mui/material';

const Scores = ({ paper }) => {
  return (
    <Tooltip title={`Reranking/Prefetching scores`} placement="bottom">
      <Box
        sx={{
          display: 'inline-flex',
          alignItems: 'center',
          justifyContent: 'center',
          flexDirection: 'row',
          marginLeft: '5px',
          padding: '0px 2px',
          boxSizing: 'border-box',
          color: (theme) =>
            theme.palette.mode === 'light' ? 'black' : 'white',
        }}
      >
        <Typography variant="body2" fontWeight="bold" color="gray">
          {Math.round(paper.prefetchingScore * 100)}%
        </Typography>
      </Box>
    </Tooltip>
  );
};

export default Scores;
